export default "__VITE_ASSET__Bn0vyPIY__"